import { render, staticRenderFns } from "./MarkingQuestion.vue?vue&type=template&id=dacec43e&"
import script from "./MarkingQuestion.vue?vue&type=script&lang=js&"
export * from "./MarkingQuestion.vue?vue&type=script&lang=js&"
import style0 from "./MarkingQuestion.vue?vue&type=style&index=0&id=dacec43e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports